<div [id]="sliderId"></div>
